module.exports = __webpack_public_path__ + "static/media/3 07 Tulleord Gjalte er feil.4c508b55.mp3";